<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.interfaceNav.overview')" link="interfaces" />
    <item-nav-group v-if="hasAnyLicense(['InterfaceHotelSpider', 'InterfaceInteralpSalesbox', 'iCalImport'])"
                    :open="false"
                    :label="$t('layout.nav.admin.interfaceNav.channelManager')">
      <item-nav-group-item v-if="hasLicense('InterfaceHotelSpider')"
                           :label="hotelSpiderName"
                           link="interfaces.hotelSpider" />
      <!--                     && !(['Rainmaker'].includes(hotelSettings.hotel.whiteLabel) && !hasLicense('ROLE_SYSADMIN')) -->
      <template v-if="hasLicense('InterfaceInteralpSalesbox')">
        <item-nav-group-item v-for="it in salesboxIds"
                             :key="it"
                             :params="{ interfaceId: it }"
                             label="Salesbox"
                             link="interfaces.interalpSalesbox"/>
      </template>
      <item-nav-group-item v-if="hasLicense('iCalImport')"
                           label="iCal"
                           link="interfaces.iCal" />
    </item-nav-group>
    <template v-if="hasLicense('InterfaceCmConnectS') && (['Hotelmeister','Rainmaker'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))">
      <item-nav-group :open="false" label="Connect.S">
        <item-nav-group-item label="Connect.S"
                             link="interfaces.connectS" />
        <item-nav-group-item v-if="suApiVersion === 'v1'"
                             label="Connect.S Mapping"
                             link="interfaces.connectSmapping" />
        <item-nav-group-item v-if="suApiVersion === 'v2'"
                             label="Connect.S Mapping"
                             link="interfaces.connectSmappingV2" />
        <template v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
          <item-nav-group-item v-if="suApiVersion === 'v2'"
                               label="Connect.S ARR 🔒"
                               link="interfaces.connectSarrV2" />
          <item-nav-group-item v-if="suApiVersion === 'v2'"
                               label="Connect.S MBS 🔒"
                               link="interfaces.connectSmbsV2" />
        </template>
      </item-nav-group>
    </template>
    <template v-if="hasLicense('InterfaceCmConnectCX') && (['Hotelmeister','AllInOne'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))">
      <template v-for="cxId in channexIds">
        <item-nav-group :key="`${cxId.id}-config`" :open="false" :label="isEmpty(cxId.name) ? 'Connect.CX' : `Connect.CX (${cxId.name})`">
          <item-nav-group-item :params="{configId: cxId.id}"
                               :key="`${cxId.id}-config`"
                               label="Connect.CX"
                               link="interfaces.connectCX" />
          <item-nav-group-item :params="{configId: cxId.id}"
                               :key="`${cxId.id}-mapping`"
                               label="Connect.CX Mapping"
                               link="interfaces.connectCXmapping" />
          <item-nav-group-item :params="{configId: cxId.id}"
                               :key="`${cxId.id}-property`"
                               label="Connect.CX Property"
                               link="interfaces.connectCXproperty" />
          <template v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
            <item-nav-group-item :params="{configId: cxId.id}"
                                 :key="`${cxId}-dashboard`"
                                 label="Connect.CX Dashboard 🔒"
                                 link="interfaces.connectCXdashboard" />
            <item-nav-group-item :params="{configId: cxId.id}"
                                 :key="`${cxId.id}-inventory`"
                                 label="Connect.CX Inventory 🔒"
                                 link="interfaces.connectCXinventory" />
            <item-nav-group-item :params="{configId: cxId.id}"
                                 :key="`${cxId.id}-rooms`"
                                 label="Connect.CX Rooms 🔒"
                                 link="interfaces.connectCXrooms" />
          </template>
        </item-nav-group>
      </template>
    </template>
    <item-nav-group v-if="hasLicense('GenericPOS')" :open="false" label="POS">
      <item-nav-group-item v-if="hasLicense('GenericPOS')"
                           :label="$t('layout.nav.admin.interfaceNav.genericPos')"
                           link="interfaces.genericPos" />
    </item-nav-group>
    <item-nav-group v-if="hasLicense('InterfaceMeldeblatt')" :open="false" :label="$t('layout.nav.admin.interfaceNav.meldewesen')">
      <item-nav-group-item v-for="it in meldeclients"
                           :key="it.id"
                           :label="`${it.name || $t('layout.nav.admin.interfaceNav.printFeratel')} (${$t(`MeldeclientTyp.${it.type}`)})`"
                           :params="{ interfaceId: it.id }"
                           link="interfaces.meldeclient"/>
    </item-nav-group>
    <item-nav-group v-if="hasLicense('InterfaceATrustRegMobile')" :open="false" :label="$t('layout.nav.admin.interfaceNav.registrierkasse')">
      <item-nav-group-item :label="$t('layout.nav.admin.interfaceNav.aTrustRegMobile')"
                           link="interfaces.aTrustRegMobile" />
    </item-nav-group>
    <item-nav-group v-if="hasLicense('ExchangeRates') && hasRole('ROLE_SYSADMIN')" :open="false" :label="$t('layout.nav.admin.interfaceNav.exchangeRates')">
      <item-nav-group-item :label="$t('layout.nav.admin.interfaceNav.exchangeRates')"
                           link="interfaces.exchangeRates" />
    </item-nav-group>
    <item-nav-group v-if="hasLicense('InterfaceFiskaltrustDE') || (hasRole('ROLE_SYSADMIN') && hotelSettings.details.countryCode === 'DE')" :open="false" :label="$t('layout.nav.admin.interfaceNav.fiskaltrustDE')">
      <item-nav-group-item :label="$t('layout.nav.admin.interfaceNav.fiskaltrustDE')"
                           link="interfaces.fiskaltrustDE" />
    </item-nav-group>
    <item-nav-group v-if="hasAnyLicense(['InterfaceMollie', 'InterfaceStripe', 'InterfaceFanz'])" :open="false" :label="$t('layout.nav.admin.interfaceNav.paymentServiceProviders')">
      <item-nav-group-item v-if="hasLicense('InterfaceStripe')"
                           :label="$t('layout.nav.admin.interfaceNav.stripe')"
                           link="interfaces.stripe" />
      <item-nav-group-item v-if="hasLicense('InterfaceFanz')"
                           :beta="true"
                           :label="$t('layout.nav.admin.interfaceNav.fanz')"
                           link="interfaces.fanz" />
      <item-nav-group-item v-if="hasLicense('InterfaceMollie')"
                           :label="$t('layout.nav.admin.interfaceNav.mollie')"
                           link="interfaces.mollie" />
    </item-nav-group>
    <item-nav-group v-if="hasLicense('InterfaceCharPmsLink')" :open="false" :label="$t('layout.nav.admin.interfaceNav.charPmsLink')">
      <template v-for="configId in charPmsLinkIds">
        <item-nav-group-item :key="configId"
                             :label="$t('layout.nav.admin.interfaceNav.charPmsLinkItem')"
                             :params="{configId: configId}"
                             link="interfaces.charPmsLink" />
      </template>
    </item-nav-group>
    <item-nav-item v-if="hasAnyLicense(['LockingSystems'])"
                   :label="$t('layout.nav.admin.interfaceNav.locking')"
                   :exact="false"
                   class="item-nav__hr"
                   link="interfaces.locking" />
    <item-nav-item v-if="hasLicense('InterfaceSmartpricing')"
                   :label="$t('layout.nav.admin.interfaceNav.smartpricing')"
                   class="item-nav__hr"
                   link="interfaces.smartpricing" />
    <item-nav-item v-if="hasLicense('PaymentRequests')"
                   :label="$t('layout.nav.admin.interfaceNav.paymentRequest')"
                   class="item-nav__hr"
                   link="interfaces.paymentRequest" />
    <item-nav-item v-if="hasLicense('PaymentRequests') && hasLicense('InterfaceStripe') && hasLicense('StripeTerminal')"
                   :label="$t('layout.nav.admin.interfaceNav.terminalPaymentRequest')"
                   class="item-nav__hr"
                   link="interfaces.terminalPaymentRequest" />
    <item-nav-item v-if="hasLicense('OnlineBooking')"
                   :label="$t('layout.nav.admin.interfaceNav.onlineBooking')"
                   class="item-nav__hr"
                   link="interfaces.onlineBooking" />
    <item-nav-item v-if="hasLicense('Kiosk')"
                   :label="$t('layout.nav.admin.interfaceNav.kiosk')"
                   class="item-nav__hr"
                   link="interfaces.kiosk" />
    <item-nav-item v-if="hasLicense('SelfCheckIn') && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                   :label="$t('layout.nav.admin.interfaceNav.selfCheckIn')"
                   :beta="true"
                   class="item-nav__hr"
                   link="interfaces.selfCheckIn" />
    <item-nav-item v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                   :label="`${$t('layout.nav.admin.interfaceNav.logs')} 🔒`"
                   class="item-nav__hr"
                   link="interfaces.logs" />
    <item-nav-item v-if="hasLicense('InterfaceCmConnectS') && hasRole('ROLE_SYSADMIN')"
                   label="Logs (Connect.S)"
                   link="interfaces.connectSlogs" />

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'InterfaceNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      interfaces: [],
      meldeclients: [],
      salesboxIds: [],
      channexIds: [],
      charPmsLinkIds: [],
    };
  },

  computed: {
  },

  created: function () {
    this.loadData();
    this.$serviceBus.$on('interface.list', this.loadData);
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('interface.list', this.updateInHouseServices);
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.meldeclient.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            // this.meldeclientIds = response.data.data.map(it => it.id);
            this.meldeclients = response.data.data.map(it => ({ id: it.id, name: it.name, type: it.typ }));
          }
        });
      this.axios.get(this.serviceUrls.interfaces.interalpSalesbox.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            this.salesboxIds = response.data.data.map(it => it.id);
          }
        });
      this.axios.get(this.serviceUrls.interfaces.channelManagerCx.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            this.channexIds = response.data.data.map(it => ({ id: it.id, name: it.name }));
          }
        });
      this.axios.get(this.serviceUrls.interfaces.charPmsLink.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            this.charPmsLinkIds = response.data.data.map(it => it.id);
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/InterfaceNav.vue